import ServicePageLayout from "@/components/ServicePageLayout";
import { IMAGES } from "@/data/site";

export default function MaintenanceConsultancy() {
    return (
        <ServicePageLayout
            seoTitle="Maintenance Consultancy | The Sens Civil Works Consultancy — Gorakhpur"
            seoDescription="Maintenance assessment and planning for homes, properties, housing societies and institutions in Gorakhpur — practical, prioritised recommendations."
            overline="Maintenance Consultancy"
            title="Plan Maintenance Before It Becomes Repair"
            heroDescription="Assessment of maintenance requirements and preparation of practical maintenance recommendations — for homes, properties, societies and institutions."
            image={IMAGES.maintenance.url}
            imageAlt={IMAGES.maintenance.alt}
            intro={[
                "Buildings rarely fail suddenly; they decline quietly — a damp patch, a hairline crack, a leaking terrace — until a small maintenance item becomes a major repair bill.",
                "A structured maintenance assessment identifies what needs attention now, what can wait, and what should simply be monitored — documented so committees, owners and contractors are all working from the same page.",
            ]}
            coveredTitle="What the Assessment Covers"
            covered={[
                "Walkthrough assessment of visible maintenance conditions",
                "Prioritised list of maintenance items — urgent, planned, monitor",
                "Practical recommendations on method and sequence",
                "Maintenance planning for housing societies and institutions",
                "Review of maintenance quotations and contractor bills",
                "Periodic re-assessment to track condition over time",
            ]}
            closing="Recommendations are practical and prioritised — aimed at sensible planning, not inflated scopes of work."
            ctaLabel="Request Maintenance Assessment"
            ctaLink="/contact?service=Maintenance%20Consultancy"
        />
    );
}
